import { render, staticRenderFns } from "./LogInView.vue?vue&type=template&id=352fb9b5&scoped=true&lang=html"
import script from "./LogInView.vue?vue&type=script&lang=js"
export * from "./LogInView.vue?vue&type=script&lang=js"
import style0 from "./LogInView.vue?vue&type=style&index=0&id=352fb9b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fb9b5",
  null
  
)

export default component.exports